module.exports = __webpack_public_path__ + "static/media/balls.895b9394.webp";